import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { FileUploadModule } from 'ng2-file-upload';
import { TreeviewModule } from 'ngx-treeview';
import { SharedModule } from '../shared/shared.module';
import { ChiefEditorRoutingModule } from './chief-editor-routing.module';
import { ChiefEditorComponent } from './chief-editor.component';
import { AddEventComponent } from './components/add-event/add-event.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { RawImageAssignUpsertComponent, RawImageManageComponent, RawImagePendingGroupedComponent } from './components/raw-image';
import { EventService } from './services/event.service';
import { RawImageService } from './services/raw.image.service';
import { UserService } from './services/user.service';

@NgModule({
    declarations: [
        ChiefEditorComponent,
        DashboardComponent,
        RawImagePendingGroupedComponent,
        AddEventComponent,
        RawImageAssignUpsertComponent,
        RawImageManageComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        ChiefEditorRoutingModule,
        NgbModule,
        FileUploadModule,
        TreeviewModule.forRoot(),
        NgMultiSelectDropDownModule.forRoot()
    ],
    entryComponents: [
        RawImageAssignUpsertComponent
    ],
    providers: [
        UserService,
        EventService,
        RawImageService
    ],
})

export class ChiefEditorModule { }
